export const GREETINGS_MESSAGE_TITLE_MORNING = 'greetings-message.title-morning';
export const GREETINGS_MESSAGE_TITLE_AFTERNOON = 'greetings-message.title-afternoon';
export const GREETINGS_MESSAGE_TITLE_EVENING = 'greetings-message.title-evening';
export const GREETINGS_MESSAGE_SUBTITLE = 'greetings-message.subtitle';
export const GREETINGS_MESSAGE_MISSIO_LABEL = 'greetings-message.missio-label';
